//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/components/Ads/index.vue